import { applyFilters, doRequest } from "./helpers";

export default class RevenueOpportunityRecipientPresetService {
  static async getRevenueOpportunityRecipientPresets() {
    return doRequest("GET", "/revenue_opportunity_recipient_preset/");
  }

  static async getRevenueOpportunityRecipientPresetsAsTable(filters = null) {
    let path = "/revenue_opportunity_recipient_preset/table";
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }

  static async createRevenueOpportunityRecipientPreset(name, recipients) {
    const data = { name, recipients };
    return doRequest("POST", "/revenue_opportunity_recipient_preset/", {
      data,
    });
  }

  static async getRevenueOpportunityRecipientPreset(id) {
    return doRequest("GET", `/revenue_opportunity_recipient_preset/${id}`);
  }

  static async editRevenueOpportunityRecipientPreset(id, name, recipients) {
    const data = { name, recipients };
    return doRequest("PUT", `/revenue_opportunity_recipient_preset/${id}`, {
      data,
    });
  }

  static async deleteRevenueOpportunityRecipientPreset(id) {
    return doRequest("DELETE", `/revenue_opportunity_recipient_preset/${id}`);
  }
}
